export default __webpack_public_path__ + "static/media/EM0370.34I-22414_-15114_0.555af375.jpg";